// @ts-strict-ignore
import { getUser } from "@braze/web-sdk-develop";
import { captureException } from "@sentry/browser";

const CSRFtoken = { current: undefined };

export const getToken = () => {
  if (!CSRFtoken.current) {
    const metatag: HTMLMetaElement = document.querySelector('meta[name="csrf-token"]');
    if (metatag) {
      CSRFtoken.current = metatag.content;
    } else {
      try {
        throw "CSRF token cannot be found";
      } catch (e) {
        captureException(e);
        getUser()?.incrementCustomUserAttribute("js-errors");
      }
    }
  }
  return CSRFtoken.current;
};
